const isObject = maybeObj => {
  return typeof maybeObj === 'object' && maybeObj !== null;
};
export default isObject;